import { render, staticRenderFns } from "./SAWorkPermitTnC.vue?vue&type=template&id=38e34a36&scoped=true&"
import script from "./SAWorkPermitTnC.vue?vue&type=script&lang=js&"
export * from "./SAWorkPermitTnC.vue?vue&type=script&lang=js&"
import style0 from "./SAWorkPermitTnC.vue?vue&type=style&index=0&id=38e34a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e34a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e34a36')) {
      api.createRecord('38e34a36', component.options)
    } else {
      api.reload('38e34a36', component.options)
    }
    module.hot.accept("./SAWorkPermitTnC.vue?vue&type=template&id=38e34a36&scoped=true&", function () {
      api.rerender('38e34a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/SAWorkPermitTnC.vue"
export default component.exports